import { mapCanonicalApiListing } from "./canonicalProperties";
import {
  getAvailabilityBadge,
  getFreshnessBadge,
  getSourceTrustBadge,
} from "./propertyTrustBadges";

export function mapPropertyDetailResponse(raw = {}) {
  const property = raw.property || raw;
  const base = mapCanonicalApiListing({
    ...property,
    canonical_property_id: property.canonicalPropertyId || property.id,
    price_history: property.priceHistory,
    favorited: property.favorited,
    favorite_listing_id: property.favoriteListingId,
  });

  return {
    ...base,
    formattedPrice: property.formattedPrice || null,
    price: property.price ?? base.priceMin,
    pricePeriod: property.pricePeriod || null,
    administrationFee: property.administrationFee ?? null,
    builtAreaM2: property.builtAreaM2 ?? base.areaM2,
    lotAreaM2: property.lotAreaM2 ?? null,
    addressText: property.addressText || property.location?.displayAddress || null,
    department: property.department || property.location?.department || null,
    highlights: property.highlights || [],
    shortSummary: property.shortSummary || null,
    listingHistory: property.listingHistory || [],
    insights: property.insights || [],
    amenityGroups: property.amenityGroups || [],
    location: property.location || {
      displayAddress: property.addressText,
      neighborhood: property.neighborhood,
      municipality: property.municipality || property.city,
      department: property.department,
      country: property.country,
      latitude: property.latitude,
      longitude: property.longitude,
      mapLatitude: property.latitude,
      mapLongitude: property.longitude,
      approximateLocation: property.approximateLocation,
      locationPending: property.locationPending ?? base.locationPending,
      locationQuality: property.locationQuality,
      coordinateConfidence: property.coordinateConfidence,
    },
    marketFit: property.marketFit || { available: false },
    admin: property.admin || null,
    canonicalStatus: property.canonicalStatus || null,
    createdAt: property.createdAt || null,
    availabilityBadge: getAvailabilityBadge(property.availabilityStatus || base.availabilityStatus),
    freshnessBadge: getFreshnessBadge(property.lastSeenAt || base.lastSeenAt),
    sourceTrustBadge: getSourceTrustBadge(property.activeSourceCount ?? base.activeSourceCount),
    isDetailPage: true,
  };
}
